import React, { createContext, useContext, useEffect, useState } from 'react';

const CurrentMemorialContext = createContext({ slug: null, memorialId: null, setCurrent: () => {} });

export function CurrentMemorialProvider({ children }) {
  const [slug, setSlug] = useState(null);
  const [memorialId, setMemorialId] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem('currentMemorial');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setSlug(parsed.slug || null);
        setMemorialId(parsed.memorialId || null);
      } catch (_) {}
    }
  }, []);

  const setCurrent = (next) => {
    setSlug(next?.slug || null);
    setMemorialId(next?.memorialId || null);
    localStorage.setItem('currentMemorial', JSON.stringify({ slug: next?.slug || null, memorialId: next?.memorialId || null }));
  };

  return (
    <CurrentMemorialContext.Provider value={{ slug, memorialId, setCurrent }}>
      {children}
    </CurrentMemorialContext.Provider>
  );
}

export function useCurrentMemorial() {
  return useContext(CurrentMemorialContext);
}


